/* Badges sobre la foto del producto.

   Hacen dos cosas:
   1. Cambiar con la variante. Impact re-renderiza la columna de texto al
      elegir un color, pero NO la galería, así que los badges quedarían
      congelados en los de la primera variante. Se imprime un juego por
      variante y acá se muestra el que corresponde.
   2. Verse SOLO en la foto principal. Al pasar a las siguientes tapaban los
      textos de las imágenes, así que se ocultan al salir de esa. La "foto
      principal" es la destacada de la variante elegida, no siempre la nº 1:
      por eso el índice llega por atributo y se recalcula al cambiar de color. */
if (!window.customElements.get('smud-gallery-badges')) {
  window.customElements.define(
    'smud-gallery-badges',
    class extends HTMLElement {
      connectedCallback() {
        this._abortController = new AbortController();
        const opciones = { signal: this._abortController.signal };

        this._firstIndex = parseInt(this.getAttribute('first-index'), 10) || 0;

        const form = document.forms[this.getAttribute('form')];
        form?.addEventListener('variant:change', this._onVariantChanged.bind(this), opciones);

        this._gallery = this.closest('product-gallery');
        this._gallery?.addEventListener('carousel:change', this._onCarouselChanged.bind(this), opciones);
      }

      disconnectedCallback() {
        this._abortController?.abort();
      }

      _onVariantChanged(event) {
        const variant = event.detail?.variant;
        if (!variant) return;

        if (variant.featured_media) {
          this._firstIndex = variant.featured_media.position - 1;
        }

        this.querySelectorAll('[data-variant-id]').forEach((slot) => {
          slot.toggleAttribute('hidden', slot.dataset.variantId !== String(variant.id));
        });

        // al cambiar de color la galería salta a la foto principal
        this.toggleAttribute('hidden', false);
      }

      _onCarouselChanged(event) {
        const index = event.detail?.index;
        if (typeof index !== 'number') return;
        this.toggleAttribute('hidden', index !== this._firstIndex);
      }
    }
  );
}
